var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 5.83333C35 2.76801 32.2339 0 29.1667 0H5.83333C2.76613 0 0 2.76801 0 5.83333V29.1667C0 32.232 2.76613 35 5.83333 35H17.5V21.779H13.221V15.9457H17.5V13.6726C17.5 9.75296 20.443 6.22285 24.0634 6.22285H28.779V12.0562H24.0634C23.5478 12.0562 22.9457 12.6828 22.9457 13.6218V15.9457H28.779V21.779H22.9457V35H29.1685C32.2358 35 35.0019 32.232 35.0019 29.1667V5.83333H35Z",
    fill: "#DCD7C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footerFacebook.df44aa79eba2deee6cd0dafe2a7bf5aa.svg";
export { ForwardRef as ReactComponent };